import { render } from "./TheStocks.vue?vue&type=template&id=616813d3&scoped=true"
import script from "./TheStocks.vue?vue&type=script&lang=js"
export * from "./TheStocks.vue?vue&type=script&lang=js"

import "./TheStocks.vue?vue&type=style&index=0&id=616813d3&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616813d3"]])

export default __exports__